import React, {useEffect} from 'react';
import {Box, Button} from '@mui/material';
import {UPDATES} from '../../../shared/UPDATES';
import {BuilderPlanFormsStyled} from '../CreateBuilder/BuilderSourceDestination/BuilderPlanForm';
import {SetUpNewSubplan} from './SetUpNewSubplan';
import type {newPlanFields, newSubplanFields} from './builderSetUpNewFields';
import {Pot, Pot_children} from '../../../schema-types/Pot';
import {PlanProviderSelectOption} from '../../../hooks/usePlanNamesProviders';
import {useAutoField, AutoFieldHelpers} from '../../../components/AutoForm/useAutoForm';
import {defaultFeeFields} from '../CreateBuilder/BuilderPlanFees';

export const getSavedChildSubPlans = (pots: Pot[], parentId: string): Pot_children[] => {
  if (!pots) {
    return [];
  }
  const parent = pots?.find((p) => p.id === parentId);
  if (!parent) {
    return [];
  }
  const {children} = parent;
  return children || [];
};

export const toggleSubPlanChecked = ({
  index,
  subplans,
  subplansHelpers,
}: {
  index: number;
  subplans: newSubplanFields[];
  subplansHelpers: AutoFieldHelpers<newPlanFields['subplans']>;
}) => {
  const filtered = subplans.filter((_, i) => i !== index);
  subplansHelpers.setValue(UPDATES._460, filtered);
};

interface BuilderWrappedNewSubPlansProps {
  productProviders: PlanProviderSelectOption[] | undefined;
}

export const BuilderWrappedNewSubPlans: React.FC<BuilderWrappedNewSubPlansProps> = ({
  productProviders,
}) => {
  const [subplansFieldObj, , subplansHelpers] =
    useAutoField<newPlanFields['subplans']>('setUpNew.subplans');

  // TODO: disable if transact or lowes
  const subplans = subplansFieldObj.value ?? [];

  const changeSubPlan = (index: number) => {
    toggleSubPlanChecked({index, subplans, subplansHelpers});
  };

  const handleAddSubplan = () => {
    const newSubplan: newSubplanFields = {
      existingPotId: null,
      planFees: defaultFeeFields,
    };
    subplansHelpers.setValue(UPDATES._530, [...subplans, newSubplan]);
  };

  const handleRemoveSubplan = (index: number) => {
    subplansHelpers.setValue(
      UPDATES._531,
      subplans.filter((_, i) => i !== index)
    );
  };

  return (
    <Box ml={2}>
      <BuilderPlanFormsStyled>
        {subplans.map((subplan, index) => (
          <Box key={subplan.existingPotId ?? `new-${index}`}>
            <SetUpNewSubplan
              index={index}
              subplanId={subplan.existingPotId}
              formikKeyPrefix={`setUpNew.subplans.${index}`}
              handleChange={() => changeSubPlan(index)}
              productProviders={productProviders}
              onRemove={
                subplan.existingPotId === null
                  ? () => handleRemoveSubplan(index)
                  : undefined
              }
            />
          </Box>
        ))}
      </BuilderPlanFormsStyled>
      <Box mt={1} display="flex" justifyContent="center">
        <Button variant="contained" size="large" onClick={handleAddSubplan}>
          Add Subplan
        </Button>
      </Box>
    </Box>
  );
};
